<template>
    <div>
        <a href="#" @click.prevent.stop="previewModel()" :class="$spa.css.contextmenu.link">
            <i :class="`${$spa.css.contextmenu.icon} far fa-eye`" />
            {{ $t('actions.see') }}
        </a>
        <a href="#" @click.prevent.stop="editModel()" :class="$spa.css.contextmenu.link">
            <i :class="`${$spa.css.contextmenu.icon} far fa-pencil`" />
            {{ $t('actions.edit') }}
        </a>
        <a class="relative" href="#" @click.prevent="duplicateToTomorrow()" :class="$spa.css.contextmenu.link" v-if="isDuplicatable">
            <v-spa-loader v-if="duplicating"></v-spa-loader>
            <i :class="`${$spa.css.contextmenu.icon} far fa-step-forward`" />
            {{ $t('calendar-event.actions.duplicate_tomorrow') }}
        </a>
        <a class="relative" href="#" @click.prevent="duplicateInWeek()" :class="$spa.css.contextmenu.link" v-if="isDuplicatable">
            <v-spa-loader v-if="duplicatingWeek"></v-spa-loader>
            <i :class="`${$spa.css.contextmenu.icon} far fa-fast-forward`" />
            {{ $t('calendar-event.actions.duplicate_week') }}
        </a>
        <a class="relative" href="#" @click.prevent.stop="deleteModel()" :class="$spa.css.contextmenu.link">
            <v-spa-loader v-if="deleting"></v-spa-loader>
            <i :class="`${$spa.css.contextmenu.icon} far fa-trash`" />
            {{ $t('actions.delete') }}
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            model: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                deleting: false,
                duplicating: false,
                duplicatingWeek: false,
            }
        },

        computed: {
            isDuplicatable()
            {
                return this.model.getStartsAt().isoWeekday() < 5;
            }
        },
        
        methods: {
            close()
            {
                this.$emit('close');
            },

            openModel()
            {
                this.model.open();
                this.close();
            },

            previewModel()
            {
                this.model.preview();
                this.close();
            },
            
            editModel()
            {
                this.model.edit();
                this.close();
            },

            async deleteModel()
            {
                this.deleting = true;

                await window.Planning.endpoints.calendarEvent
                    .delete(this.model.uuid);

                this.close();
            },

            async duplicateToTomorrow()
            {
                this.duplicating = true;

                let newCalendarEvent = this.model.requestData();
                let date = this.model.getStartsAt().add(1, 'days');
                newCalendarEvent.starts_at = date.format('YYYY-MM-DD') + ' ' + this.model.getStartsAt().format('HH:mm:ss');
                newCalendarEvent.ends_at = date.format('YYYY-MM-DD') + ' ' + this.model.getEndsAt().format('HH:mm:ss');
                await window.Planning.endpoints.calendarEvent.store(newCalendarEvent);

                this.duplicating = false;
                this.close();
            },

            async duplicateInWeek()
            {
                this.duplicatingWeek = true;
                // Find all days in week after calendar event start date
                // Create new calendar event for each day
                let startDate = this.model.getStartsAt().add(1, 'days');
                let friday = startDate.clone().isoWeekday(5);
                let range = moment.range(startDate, friday);
                
                for ( let date of range.by('day') ) {
                    let newCalendarEvent = this.model.requestData();
                    newCalendarEvent.starts_at = date.format('YYYY-MM-DD') + ' ' + this.model.getStartsAt().format('HH:mm:ss');
                    newCalendarEvent.ends_at = date.format('YYYY-MM-DD') + ' ' + this.model.getEndsAt().format('HH:mm:ss');
                    await window.Planning.endpoints.calendarEvent.store(newCalendarEvent);
                }

                this.duplicatingWeek = false;
                this.close();
            }
        }
    }
</script>
